import Api from './Api'

export default {
  build (data) {
    return Api().post('/statistikk/bekreftelsebrev/build.json', data)
  },
  getDrafts (params) {
    let query = {
      type: params.type || null,
      page: params.page || 1,
      sort: params.sort || 'id',
      direction: params.direction || 'desc',
      limit: params.limit || 500
    }

    return Api().get('/statistikk/bekreftelsebrev/drafts.json', {
      params: query
    })
  },
  deleteDrafts (items) {
    let post = {
      queue: items
    }

    return Api().post('/statistikk/bekreftelsebrev/drafts-delete.json', post)
  },
  approveMany (items) {
    let post = {
      queue: items
    }

    return Api().post('/statistikk/bekreftelsebrev/approve-many.json', post)
  },
  updateManyStatus (items) {
    let post = {
      queue: items
    }

    return Api().post('/statistikk/bekreftelsebrev/update-many-status.json', post)
  },
  loadManyForPrint (items) {
    let post = {
      queue: items
    }

    return Api().post('/statistikk/bekreftelsebrev/load-many-print.json', post)
  },
  search (params, data) {
    let query = {
      page: params.page || 1,
      sort: params.sort || 'id',
      direction: params.direction || 'desc',
      limit: params.limit || 200
    }

    return Api().get('/statistikk/bekreftelsebrev/search.json', {
      params: Object.assign(query, {}, data)
    })
  }
  // loadMany (manualQueueIdArray) {
  //   let post = {
  //     queue: manualQueueIdArray
  //   }

  //   return Api().post('/statistikk/bekreftelsebrev/load-many.json', post)
  // },
  // saveMany (manualQueueIdArray, status) {
  //   let post = {
  //     queue: manualQueueIdArray,
  //     status: status
  //   }

  //   return Api().post('/statistikk/bekreftelsebrev/unprocessed/save-many.json', post)
  // }
}



// WEBPACK FOOTER //
// ./src/services/BekreftelsebrevService.js